import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ProductForm from './ProductForm';
import { apiFetch } from '../utils/api';

const EditProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setIsFetching(true);
        const res = await apiFetch(`/api/products/${id}`);
        if (!res.ok) {
          setMessage({ type: 'error', text: 'Product not found' });
          setTimeout(() => navigate('/admin/products'), 2000);
          return;
        }
        const data = await res.json();
        setProduct(data);
      } catch (error) {
        console.error(error);
        setMessage({ type: 'error', text: 'Failed to load product' });
      } finally {
        setIsFetching(false);
      }
    };

    if (id) {
      fetchProduct();
    }
  }, [id, navigate]);

  const handleSubmit = async (data) => {
    setLoading(true);
    setMessage(null);

    try {
      const res = await apiFetch(`/api/products/${id}`, {
        method: 'PUT',
        body: data,
      });

      const responseData = await res.json();

      if (res.ok) {
        setMessage({ type: 'success', text: 'Product updated successfully!' });
        setTimeout(() => navigate('/admin/products'), 1500);
      } else {
        setMessage({ type: 'error', text: responseData.message || 'Error updating product' });
      }
    } catch (error) {
      console.error(error);
      setMessage({ type: 'error', text: 'Something went wrong' });
    } finally {
      setLoading(false);
    }
  };

  if (isFetching) {
    return (
      <div style={{ maxWidth: '1200px', margin: '40px auto', textAlign: 'center', color: '#f97316' }}>
        Loading product details...
      </div>
    );
  }

  if (!product) {
    return null;
  }

  return (
    <ProductForm
      isEdit={true}
      onSubmit={handleSubmit}
      loading={loading}
      message={message}
      initialData={product}
    />
  );
};

export default EditProduct;
